import { IEFConfiguration, IEFTargets, IEFYearTarget } from '../../Component/Model/Dto/EmpowermentFinancing';

export interface IEFPreviewInputs {
	monetaryTargetFiveYear: number;
	startYear: number;
	ratioTransformationalInfrastructure: number;
	ratioBlackAgriculturalFinancing: number;
	ratioAffordableHousing: number;
	ratioBlackBusinessGrowthFunding: number;
}

const elementFactor = (configuration: IEFConfiguration, key: string): number =>
	configuration.elements.find(e => e.key === key)?.factor ?? 0;

export const buildTargetPreview = (configuration: IEFConfiguration, inputs: IEFPreviewInputs): IEFTargets => {
	const yearCount = configuration.periodYearCount;
	const points = configuration.targetedInvestmentsWeightingPoints;

	const nonFungibleFiveYear = Math.round(inputs.monetaryTargetFiveYear * elementFactor(configuration, 'nonFungible'));
	const targetedInvestmentsFiveYear = Math.round(inputs.monetaryTargetFiveYear * elementFactor(configuration, 'targetedInvestments'));
	const transactionFinancingAndBbgfFiveYear = Math.round(inputs.monetaryTargetFiveYear * elementFactor(configuration, 'transactionFinancingAndBbgf'));

	const cumulative = (fiveYearTotal: number, yearNumber: number) =>
		Math.round((fiveYearTotal / yearCount) * yearNumber);

	const subCategory = (targetedInvestments: number, ratio: number) => Math.round((targetedInvestments * ratio) / 100);

	const years: IEFYearTarget[] = [];

	for (let offset = 0; offset < yearCount; offset++) {
		const yearNumber = offset + 1;
		const nonFungible = cumulative(nonFungibleFiveYear, yearNumber);
		const targetedInvestments = cumulative(targetedInvestmentsFiveYear, yearNumber);
		const transactionFinancingAndBbgf = cumulative(transactionFinancingAndBbgfFiveYear, yearNumber);

		years.push({
			year: inputs.startYear + offset,
			nonFungible,
			targetedInvestments,
			transactionFinancingAndBbgf,
			total: nonFungible + targetedInvestments + transactionFinancingAndBbgf,
			transformationalInfrastructure: subCategory(targetedInvestments, inputs.ratioTransformationalInfrastructure),
			blackAgriculturalFinancing: subCategory(targetedInvestments, inputs.ratioBlackAgriculturalFinancing),
			affordableHousing: subCategory(targetedInvestments, inputs.ratioAffordableHousing),
			blackBusinessGrowthFunding: subCategory(targetedInvestments, inputs.ratioBlackBusinessGrowthFunding),
		});
	}

	return {
		nonFungibleFiveYear,
		targetedInvestmentsFiveYear,
		transactionFinancingAndBbgfFiveYear,
		totalFiveYear: Math.round(inputs.monetaryTargetFiveYear),
		weightingPointsTransformationalInfrastructure: (inputs.ratioTransformationalInfrastructure / 100) * points,
		weightingPointsBlackAgriculturalFinancing: (inputs.ratioBlackAgriculturalFinancing / 100) * points,
		weightingPointsAffordableHousing: (inputs.ratioAffordableHousing / 100) * points,
		weightingPointsBlackBusinessGrowthFunding: (inputs.ratioBlackBusinessGrowthFunding / 100) * points,
		transformationalInfrastructureFiveYear: subCategory(targetedInvestmentsFiveYear, inputs.ratioTransformationalInfrastructure),
		blackAgriculturalFinancingFiveYear: subCategory(targetedInvestmentsFiveYear, inputs.ratioBlackAgriculturalFinancing),
		affordableHousingFiveYear: subCategory(targetedInvestmentsFiveYear, inputs.ratioAffordableHousing),
		blackBusinessGrowthFundingFiveYear: subCategory(targetedInvestmentsFiveYear, inputs.ratioBlackBusinessGrowthFunding),
		years,
	};
};
